import {
  HoverCard,
  Popover,
  useMediaQuery,
  usePopoverContext,
  useHoverCardContext
} from "@chakra-ui/react"

export function useHoverCardOrPopoverContext() {
  try {
    return useHoverCardContext()
  } catch {
    return usePopoverContext()
  }
}

type UseHoverCardOrPopoverProps = {
  ignoreHover?: boolean // Whether to ignore hover and always use Popover.
}
// Determine whether to use HoverCard (for hover-capable devices) or Popover (for touch devices).
function useHoverCardOrPopover(options?: UseHoverCardOrPopoverProps) {
  const [hasHover] = useMediaQuery(["(hover: hover)"])
  const HoverCardOrPopover =
    hasHover && !options?.ignoreHover ? HoverCard : Popover
  return HoverCardOrPopover
}

export default useHoverCardOrPopover
